import useConfig from 'src/config/hooks/useConfig'
import useNftContractMetadata from './useNftContractMetadata'

const useVicc = () => {
  const config = useConfig()

  const { data: vicc, ...rest } = useNftContractMetadata(
    config.tokensAddresses.vicc
  )

  return {
    vicc,
    ...rest,
  }
}

export default useVicc
